import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api } from "../lib/api";
import { formatCoins, gameLabel } from "../lib/format";
import { useLang } from "../context/LangContext";

export default function WinnersMarquee() {
  const [winners, setWinners] = useState([]);
  const { lang } = useLang();

  useEffect(() => {
    let active = true;
    const load = () =>
      api.get("/winners").then(({ data }) => active && setWinners(data)).catch(() => {});
    load();
    const id = setInterval(load, 15000);
    return () => { active = false; clearInterval(id); };
  }, []);

  const seed = winners.length
    ? winners
    : [
        { name: "R***j", game: "spin", win: 5000 },
        { name: "A***a", game: "color", win: 2250 },
        { name: "S***h", game: "dice", win: 9800 },
        { name: "P***i", game: "scratch", win: 2000 },
      ];
  const loop = [...seed, ...seed];

  return (
    <div className="relative overflow-hidden border-y border-amber-500/20 bg-black/40 py-2" data-testid="winners-marquee">
      <div className="flex w-max animate-marquee gap-8 whitespace-nowrap">
        {loop.map((w, i) => (
          <span key={i} className="flex items-center gap-2 text-sm">
            <Trophy size={15} className="text-amber-400" />
            <span className="font-semibold text-amber-200">{w.name}</span>
            <span className="text-slate-400">{lang === "hi" ? "ने जीते" : "won"}</span>
            <span className="font-mono-num font-bold text-emerald-400">+{formatCoins(w.win)}</span>
            <span className="text-slate-500">· {gameLabel(w.game, lang)}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
